
  import { Component, Prop, Vue } from 'vue-property-decorator'

  @Component
  export default class Subheading extends Vue {

    @Prop({ type: String, default: '' }) private readonly subheading!: string
    @Prop({ type: String, default: '' }) private readonly text!: string
  }
